import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { Text } from '@propertypal/web-ui/src/typography';
import React from 'react';

const NoteForAgencies = () => {
  return (
    <PageWrapper>
      <div style={{ padding: '60px 0' }}>
        <Text fontWeight="bold" style={{ marginBottom: '5px' }}>
          NOTE FOR AGENCIES:
        </Text>
        <Text>
          PropertyPal accepts direct applications only. This means, we will not accept any CVs or communication from
          agencies. If you are an agency, please do not send us any CVs, unless your company has been specifically
          instructed to do so by PropertyPal. If your agency happens to send us an unsolicited CV and we happen to hire
          that candidate, we will not be liable for any fees. Submission of any unsolicited CVs will be deemed evidence
          of you accepting these terms.
        </Text>
      </div>
    </PageWrapper>
  );
};

export default NoteForAgencies;
